import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { KudosService } from 'src/app/providers/kudos/kudos.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
declare let $: any;

@Component({
  selector: 'app-sticky-icons',
  templateUrl: './sticky-icons.component.html',
  styleUrls: ['./sticky-icons.component.scss']
})
export class StickyIconsComponent implements OnInit {
  modalId = 'feedbackMdl'
  sosForm: FormGroup;
  submit = false;

  constructor(private formBuilder: FormBuilder,
              private kudosServe: KudosService,
              private notifyService: NotificationService) { }

  ngOnInit(): void {
    this.sosFormField();
  }

  get sosErrorMsg(): any { return this.sosForm.controls; }

  sosDisk(): void{
    $('#sos-help-disk').modal('show');
  }

  sosFormField(): void {
    this.sosForm = this.formBuilder.group({
      sos_contact_no: ['', Validators.required]
    });
  }

  submitSos(): void {
    this.submit = true;
    if (this.sosForm.invalid) {
      return;
    } else {
      const sosForm = new FormData();
      sosForm.append('sos_contact_no', this.sosForm.get('sos_contact_no').value);
      // tslint:disable-next-line: deprecation
      this.kudosServe.sosService(sosForm).subscribe(res => {
        this.submit = false;
        if (res.status) {
          this.reset();
          this.notifyService.showSuccess(res.msg, 'Success!');
          $('#sos-help-disk').modal('hide');
        } else {
          this.notifyService.showInfo(res.msg, 'Info!');
        }
      }, err => {
        this.submit = false;
        this.notifyService.showError('Internal Server Error', 'Error!');
      });
      }
  }

  reset(): void {
    this.submit = false;
    this.sosForm.reset();
  }

  showHelpModal(): void{
    $(`#${this.modalId}`).modal('show');
  }
  
}
